/* Levano · buy-box star row, driven by the live Loox rating (window.LVB_LOOX). */
(function(){
  var d=window.LVB_LOOX;
  if(!d||!d.count||d.count<1)return;
  function paint(){
    var row=document.querySelector('.lvf-rating');if(!row)return;
    var stars=row.querySelectorAll('.lvf-star');
    var full=Math.round(d.avg);
    for(var i=0;i<stars.length;i++)stars[i].classList.toggle('is-on',i<full);
    var a=row.querySelector('a');
    if(a){
      a.textContent=Number(d.avg).toFixed(1)+' · '+d.count+(d.count===1?' review':' reviews');
      a.setAttribute('href','#lvf-reviews');
    }
    row.setAttribute('aria-label',Number(d.avg).toFixed(1)+' out of 5 stars from '+d.count+' reviews');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',paint);else paint();
})();
